import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import About from "./About/About";
import Projects from "./Projects/Projects";
import Blog from "./Blog/Blog";

const router = createBrowserRouter([
  {
    path: "*",
    element: <App/>,
    // errorElement: <ErrorPage/>,
    children: [
      {
        path: "about",
        element: <About/>,
      },
      {
        path: "projects",
        element: <Projects/>,
        children: [
          {
            path: ":topic",
            element: <Blog/>,
          }
        ]
      },
    ],
  },
]);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
